import styled from "styled-components";

export const StyledLink = styled.a`
    color: black;
    &:hover {
        color: #9036AA;
        transform: translate(-2px, -2px);
        transition: transform 0.2s;
      }
`;